<div
  class="c-form-element-button is-typed"
  [ngClass]="{ 'is-error': passengersErrorMsg !== '', 'is-disabled': !isEnabled }"
>
  <button
    id="passenger-selector-button-1"
    type="button"
    class="c-form-element-button__box"
    [disabled]="!isEnabled"
    (throttleClick$)="openPassengerSelectorModal()"
    aswThrottleClick
  >
    <span class="c-form-element-button__wrap">
      <span class="c-form-element-button__label">
        <span class="c-form-element-button__label-text" [innerHTML]="'label.paxNumber' | staticMsg"></span>
      </span>
      <span class="c-form-element-button__button">
        <span class="c-form-element-button__button-item">{{ this.placeholderText }}</span>
      </span>
    </span>
    <span class="u-visually-hidden" [innerHTML]="'reader.paxNumber' | staticMsg"></span>
  </button>
</div>
<asw-validation-error [errorMessage]="passengersErrorMsg"></asw-validation-error>
<div
  *ngIf="passengersErrorMsg && !isSp && searchFlightData.tripType === TripType.ROUND_TRIP"
  style="height: 20px"
></div>
